import { useContext } from 'react'
import { ToastContext } from './toastContext'

export function useToast() {
  const ctx = useContext(ToastContext)
  return ctx ? ctx.toast : () => {}
}
